import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import SvgIcon from "../../../../parts/SvgIcon";

const id = "modal-watch-videos";
const form = "watch-videos";

const SelectVideoPlaylist = ({ workflow, videoPlaylistWidgets = [] }) => {
  const { t } = useTranslation("coaching-portal");
  if (!videoPlaylistWidgets.length) {
    return (
      <Modal
        name={id}
        key={id}
        title={t("selectVideoPlaylist.title")}
        className="getting-started-video"
      >
        <div className="body flex flex-col items-center justify-center pb-6">
          <p className="s2">{t("selectVideoPlaylist.emptyTitle")}</p>
          <p className="p4 mt-4">
            {t("selectVideoPlaylist.emptyDescription")}
          </p>

          <a
            href="/coaching-portal/widgets?section=learn&learn=video-playlist"
            role="button"
            data-button-type="primary"
            className="mt-12"
          >
            {t("customWorkflows.createNew")}
          </a>
        </div>
      </Modal>
    );
  }

  return (
    <form
      action="/actions/getting-started/select-video-playlist"
      method="POST"
      id={form}
    >
      <input type="hidden" name="option" value="videos" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title={t("selectVideoPlaylist.title")}
        className="getting-started-video narrow"
      >
        <div className="body">
          <p className="p5 pb-2">
            {t("selectVideoPlaylist.selectDescription")}
          </p>

          {videoPlaylistWidgets.map(({ _id, name, description, icon }) => (
            <article
              key={_id}
              onClick={() => {
                document.getElementById(_id)?.click();
              }}
            >
              <div className="flex items-center gap-3">
                <SvgIcon src={`/img/widget-icons/${icon}.svg`} />
                <div>
                  <p className="s2">{name}</p>
                  <p className="p5 mt-2">{description}</p>
                </div>
              </div>
              <input
                type="radio"
                name="value"
                id={_id}
                value={_id}
                defaultChecked={workflow.options.videos?.playlist === _id}
              />
            </article>
          ))}

          <div className="chip info mt-4">
            <span>
              {t("selectVideoPlaylist.toAddMore")}{" "}
              <a href="/coaching-portal/widgets?section=learn&learn=video-playlist">
                {t("customWorkflows.clickHere")}
              </a>{" "}
              {t("customWorkflows.toVisitWidgetSection")}
            </span>
          </div>
        </div>

        <footer className="foot">
          <button data-button-type="primary" type="submit">
            {t("customWorkflows.selectButton")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default SelectVideoPlaylist;
